import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';
import container from '@/container';
import {
    CONTRACTS,
    SettingsChangeServiceContract,
    IResetSettingsModel,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { ContextSettings, ServerSettings } from '@/dto';

export interface SettingsState {
    changeService: SettingsChangeServiceContract | null;
    contextSettings: ContextSettings;
    server: ServerSettings;
}

const settingsChangeService = container.get<SettingsChangeServiceContract>(
    CONTRACTS.SettingsChangeService
);

const eventsService = container.get<EventsServiceContract>(
    CONTRACTS.EventsService
);

@Module({ name: 'settings', namespaced: true })
export default class SettingsModule extends VuexModule
    implements SettingsState {
    private _contextSettings: ContextSettings = {
        tileData: [],
        global: {},
        tableLayouts: {},
        settingsTypes: {},
        indicators: [],
        server: {}
    };

    private _serverSettings: ServerSettings = {};

    private _changeService: SettingsChangeServiceContract = settingsChangeService;

    public get changeService(): SettingsChangeServiceContract {
        return this._changeService;
    }

    public get contextSettings() {
        return this._contextSettings;
    }

    public get server() {
        return this._contextSettings.server;
    }

    @Action
    public async fetchSettings(): Promise<any> {
        const loadedSettings = await this.changeService.fetchSettings();
        if (loadedSettings.global.saveTileState === undefined || loadedSettings.global.saveTileState) {
            loadedSettings.tileData = await this.changeService.loadTiles();
        }

        this.setContextSettings(loadedSettings);
    }

    @Action
    public async changeSetting(args: {
        key: string;
        value: string;
    }): Promise<any> {
        const { key, value } = args;
        await this.changeService.changeSetting(key, value);

        this.setGlobalByKey({ key, value: value! });
    }

    @Action
    public async resetSettings(resetModel: IResetSettingsModel) {
        await this.changeService.resetSettings(resetModel);

        await this.fetchSettings();
    }

    @Mutation
    private setContextSettings(payload: ContextSettings) {

        this._contextSettings = payload;

        eventsService.raise(Events.SettingsChanged, {payload});
    }

    @Mutation
    private setGlobalByKey(payload: { key: string, value: string }) {
        this._contextSettings.global[payload.key] = payload.value;
    }

}
